import MicroModal from "micromodal";

class FormRequest {
    constructor(selector) {
        this.requestForms = document.querySelectorAll(selector);
        return this.onSubmitHandler();
    }
    onSubmitHandler() {
        this.requestForms.forEach(form => {
            form.addEventListener('submit', this.sendRequest);
        })
    }
    sendRequest(event) {
        event.preventDefault();
        let form = event.target;
        let data = new FormData(form);
        data.append('message', data.get('service') + ' - ' + data.get('city'));

        fetch(form.action, {
                method: form.method,
                credentials: 'same-origin',
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    "X-Requested-With": "XMLHttpRequest"
                },
                body: new URLSearchParams(data).toString()
            })
            .then(response => {
                if (response.ok) {
                    if (!!window.send_calltouch){ window.send_calltouch(form.phone.value); }
                    //ym(65982688, 'reachGoal', 'OrderDone');
                    //ga('send', 'event', 'button', 'Order');
                    return Promise.resolve(response);
                } else {
                    return Promise.reject(new Error('Failed to load'));
                }
            })
            .then(response => response.json())
            .then(data => {
                const modals = {
                    'true': 'modal-success',
                    'false': 'modal-error'
                };
                document.querySelector(`#${modals[data.status]} .modal__subtext`).innerHTML = data.message;
                MicroModal.show(modals[data.status]);
                form.reset();
            })
            .catch(error => {
                console.log(`Error: ${error.message}`);
            });
    }
}
export default FormRequest;
